// extracted by mini-css-extract-plugin
module.exports = {"switcher":"TabLineBot_switcher_aKA2s"};